import React, { useState } from "react";
import {Dialog, DialogActions, Grid} from "@material-ui/core";
import { useSetState } from "Helpers/Hooks";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";
import DialogContent from "@material-ui/core/DialogContent";
import { useDispatch, useSelector } from "react-redux";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import UnitBarService from "Services/http/endpoints/design/UntiBarService";
import StatusHandler from "Helpers/StatusHandler";
import { DESIGN_UNIT_LIST, SELECTED_UNIT_ID } from "Stores/actionTypes";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core/styles';

function EditUnit({ open, handleDialog }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const [loc, setLoc] = useState('-');
  const { unitList, selectedUnitImage, selectedUnitINfo, selectedUnitId, unitListPagination } = useSelector(
    (state) => ({
      unitList: state.design.unitList,
      selectedUnitImage: state.design.selectedUnitImage,
      selectedUnitINfo: state.design.selectedUnitINfo,
      selectedUnitId: state.design.selectedUnitId,
      unitListPagination: state.design.unitListPagination,
    })
  );
  const [data, setData] = useState(null);
  const [formValid, setFormValid] = useState({});

  const [controls, setControls] = useSetState({
    nameUnit: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    placeLocation: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    numberUnit: {
      type: "number",
      value: "1",
      validation: {
        required: true,
      },
    },
  });
  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };
  const dispatch = useDispatch();

  const onEnter = () => {
    const updateData = unitList.find((item) => {
      return selectedUnitId.toString() === item.Id.toString();
    });
    if(updateData) {
      setLoc('ListUnit');
      setControls({ nameUnit: { value: updateData?.Name } });
      setControls({ placeLocation: { value: updateData?.Location } });
      setControls({ numberUnit: { value: updateData?.CountUnit } });
      setData(updateData);
    } else if(selectedUnitINfo && selectedUnitINfo.Id === selectedUnitId) {
      setLoc('Local');
      setControls({ nameUnit: { value: selectedUnitINfo.Name } });
      setControls({ placeLocation: { value: selectedUnitINfo.Location } });
      setControls({ numberUnit: { value: selectedUnitINfo.CountUnit } });
      selectedUnitINfo.Image = selectedUnitImage;
      setData(selectedUnitINfo);
    } else {
      showNotify({
        text: t('getDataError'),
        customClass: "error",
      });
    }
  };

  const onFinish = async (e) => {
    e.preventDefault();
    const { nameUnit, placeLocation, numberUnit } = controls;
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdUnit: selectedUnitId,
          Name: nameUnit.value,
          Location: placeLocation.value,
          CountUnit: numberUnit.value,
        };
        const response = await UnitBarService.updateUnit(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          showNotify({
            text: t('wasEditedSuccessfully'),
            customClass: "success",
          });
        }
        handleDialog();
        if(loc === 'Local') {
          dispatch({
            type: SELECTED_UNIT_ID,
            selectedUnitINfo: {
              ...selectedUnitINfo,
              Name: nameUnit.value,
              Location: placeLocation.value,
              CountUnit: numberUnit.value,
            },
          });
        } else if(loc === 'ListUnit') {
          let updateList = [...unitList];
          const index = unitList.findIndex((item) => {
            return selectedUnitId.toString() === item.Id.toString();
          });
          updateList[index] = {
            ...updateList[index],
            Name: nameUnit.value,
            Location: placeLocation.value,
            CountUnit: numberUnit.value,
          };
          dispatch({
            type: DESIGN_UNIT_LIST,
            unitList: updateList,
            unitListPagination: unitListPagination,
          });
        }
      } catch (err) {
      console.error('[catch error]', err)
    }
    } else if (R.isEmpty(formValid)) {
      handleDialog();
    } else {
      showNotify({
        text: t('invalidInformation'),
        customClass: "error",
      });
    }
  };

  return (
    <>
      <Dialog
        dir={direction}
        open={open}
        onEnter={onEnter}
        onClose={handleDialog}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>ویرایش یونیت</p>
          </div>
          <DialogContent>
            <Grid container spacing={1}>
              <Grid item xs={12} className="d-flex justify-content-center mb-2">
                <img
                  src={`data:image/png;base64, ${data?.Image}`}
                  alt=""
                  width={200}
                />
              </Grid>
              {Object.keys(controls).map((key, index) => {
                return (
                  <Grid item xs={4} key={key + index}>
                    {controls[key].type === "text" && (
                      <Input
                        setValue={setValue.bind(this)}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type="text"
                        value={controls[key].value}
                      />
                    )}
                    {controls[key].type === "number" && (
                      <Input
                        setValue={setValue.bind(this)}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type="number"
                        value={controls[key].value}
                      />
                    )}
                  </Grid>
                );
              })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default EditUnit;
